import joinDefinedStringParts from "@utils/joinDefinedStringParts";

type TAddressStringParams = {
  street?: string;
  houseNo?: string;
  flatNo?: string;
  city?: string;
  zip?: string;
  country?: string;
  comments?: string;
};

const getAddressString = ({ street, houseNo, flatNo, city, zip, country, comments }: TAddressStringParams): string => {
  const houseFlatNumbers = joinDefinedStringParts([houseNo, flatNo], " - ");
  const streetHouse = joinDefinedStringParts([street, houseFlatNumbers, city], " ");
  const zipCountry = joinDefinedStringParts([zip, country], " ");
  const address = joinDefinedStringParts([streetHouse, zipCountry, comments], ", ");
  return address;
};
export default getAddressString;
